import { useState } from 'react';
import { motion } from 'framer-motion';

const lineVariants = {
  hidden: { y: '110%', rotate: 2 },
  show: (i) => ({ y: 0, rotate: 0, transition: { duration: 1.1, delay: i * 0.14, ease: [0.16, 1, 0.3, 1] } }),
};

// Cloud typography: masked line-by-line reveal with a volumetric glow behind the words.
// whileInView lives on the heading (not the clipped lines) so IntersectionObserver can see it.
export function CloudText({ lines, as: Tag = 'h2', className = '', size = 'text-4xl sm:text-5xl lg:text-7xl', delay = 0, testId }) {
  const MotionTag = motion[Tag] || motion.h2;
  const [done, setDone] = useState(false);
  return (
    <div className="relative inline-block">
      <div className="absolute -inset-x-24 -inset-y-16 pointer-events-none" style={{ background: 'radial-gradient(ellipse at 45% 50%, rgba(255,255,255,0.2), rgba(255,255,255,0) 58%)', filter: 'blur(30px)' }} />
      <MotionTag className={`cloud-text relative ${size} ${className}`} data-testid={testId} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.3 }} transition={{ delayChildren: delay }} onAnimationComplete={() => setDone(true)}>
        {lines.map((line, i) => (
          <span key={i} className={`block pb-[0.1em] -mb-[0.1em] ${done ? '' : 'overflow-hidden'}`}>
            <motion.span className="block" variants={lineVariants} custom={i}>{line}</motion.span>
          </span>
        ))}
      </MotionTag>
    </div>
  );
}

export function Reveal({ children, delay = 0, className = '', y = 40 }) {
  return (
    <motion.div className={className} initial={{ opacity: 0, y, filter: 'blur(8px)' }} whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}>
      {children}
    </motion.div>
  );
}

export function AltitudeMarker({ index, label }) {
  return (
    <div className="hidden lg:flex absolute left-6 top-[18vh] items-center gap-4 select-none" aria-hidden>
      <span className="font-display text-[0.6rem] tracking-[0.4em] text-white/40 [writing-mode:vertical-rl] rotate-180">ALTITUDE {index} · {label}</span>
      <span className="h-24 w-px bg-gradient-to-b from-white/0 via-white/40 to-white/0" />
    </div>
  );
}
